/**
 * CTA script
 */

(function carouselScript($, Drupal) {
  'use strict';

  Drupal.behaviors.cta = {
    attach: function ctaAttach($context) {
      // Track click on button within CTA
      $('.cta', $context).on('click', '.button', function ctaClick(e) {
        if (drupalSettings.pin_analytics && drupalSettings.pin_analytics.cta && window.ga && window.ga.loaded) {
          // Do not navigate immediately
          e.preventDefault();
          var dataLayer = window.dataLayer = window.dataLayer || [];
          // Title within CTA block
          let eventLabel = ($('.cta__title').data('source-title')) ? $('.cta__title').data('source-title').trim() : $(e.delegateTarget).text().trim();
          // Instead fire event to GA
          window.ga('send', {
            hitType: 'event',
            eventCategory: 'CTA',
            eventAction: 'click',
            eventLabel: eventLabel,
            // Navigate after successful GA track
            hitCallback: function ctaClickGACallback() {
              window.location.assign(e.target.href);
            }
          });
          dataLayer.push({'event':'click', 'eventCategory': 'CTA', 'eventLabel': eventLabel});
        }
      });
    }
  };
}(jQuery, Drupal));
